import Header from 'components/headers/bulletins'
import AddIcon from 'assets/images/bulletin/Subtract.svg'
import { useLocation, useSearchParams } from 'react-router-dom'
import DeleteIcon from 'assets/images/deletes/delete-black-1.png'
import { useEffect, useRef, useState } from 'react'
import posthog from 'posthog-js'
import useGetMoneyPoolManagement from '../fundPage/hooks/useGetMoneyPoolManagement'
import AddBulletinModal from 'components/modals/addbulletin'
import useGetBulletins from '../fundPage/hooks/useGetBulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import useDeleteBulletin from './hooks/useDeleteBulletin'
export default function BulletinPage() {
    const [isOpen, setOpen] = useState<boolean>(false)
    const {
        state,
    }: {
        state: {
            bulletins: Array<IBulletiens>
            isManager: boolean
            moneyPool: string | undefined
        }
    } = useLocation()
    // From a message (`?fund=32308&post=88`) there is no navigation state:
    // the fund comes from the address and the role from the fund itself.
    const [searchParams] = useSearchParams()
    const moneyPool = state?.moneyPool ?? searchParams.get('fund') ?? undefined
    const focusPost = searchParams.get('post')
    const { moneyPoolManagement } = useGetMoneyPoolManagement(moneyPool)
    const role = moneyPoolManagement?.poolship?.role
    const isManager = state?.isManager ?? (role === 'mgr' || role === 'own')
    const { bulletins, isLoadingBulletins, refetch } =
        useGetBulletins(moneyPool)
    const [litPost, setLitPost] = useState<string | null>(null)
    const focused = useRef(false)
    useEffect(() => {
        if (!focusPost || focused.current || !bulletins) return
        const card = document.getElementById(`bulletin-${focusPost}`)
        focused.current = true
        posthog.capture('bulletin_post_focused', {
            fund_id: Number(moneyPool),
            found: !!card,
        })
        if (!card) return
        card.scrollIntoView?.({ block: 'center', behavior: 'smooth' })
        setLitPost(focusPost)
    }, [focusPost, bulletins, moneyPool])
    useEffect(() => {
        if (!litPost) return
        const timer = window.setTimeout(() => setLitPost(null), 4000)
        return () => window.clearTimeout(timer)
    }, [litPost])
    const { mutate } = useDeleteBulletin(refetch)
    return (
        <>
            <div className=" w-full pb-10">
                <Header title="تابلو اعلانات" />
                {isManager && (
                    <div
                        onClick={() => setOpen(true)}
                        className="mx-2 p-4 my-3 flex flex-col items-center justify-center bg-white text-green-1 border-1 border-green-1 border-dashed rounded-xl"
                    >
                        <img src={AddIcon} alt="add" />
                        <p className=" my-2">
                            {' '}
                            اعلان برای اعضای صندوق ثبت کنید
                        </p>
                    </div>
                )}
                <div className=" px-4 my-4">
                    {bulletins ? (
                        bulletins.map((item) => (
                            <div
                                key={item.id}
                                id={`bulletin-${item.id}`}
                                className={`rounded-xl pt-4 transition-colors duration-700 motion-reduce:transition-none ${
                                    litPost === String(item.id)
                                        ? 'bg-brand-soft'
                                        : 'bg-main-bg'
                                }`}
                            >
                                <div className="  px-4 items-center grid gap-4 grid-cols-3 my-3  w-full">
                                    <p className=" text-center col-span-2">
                                        {item.text}
                                    </p>
                                    <img
                                        src={item.sticker.image}
                                        alt="bulletin"
                                        className=" col-span-1"
                                        onError={(e) => {
                                            e.currentTarget.style.display =
                                                'none'
                                        }}
                                    />
                                </div>
                                {isManager && (
                                    <>
                                        <hr className=" w-full" />
                                        <div className=" text-center py-2 my-1 text-error-3 rounded-md ">
                                            <img
                                                src={DeleteIcon}
                                                alt="delete"
                                                className=" w-10 mx-auto"
                                                onClick={() => {
                                                    mutate({
                                                        moneypoolId: moneyPool,
                                                        id: item.id,
                                                    })
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        ))
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </div>
            <AddBulletinModal
                show={isOpen}
                onHide={() => setOpen(false)}
                refetch={refetch}
                moneyPool={moneyPool}
            />
        </>
    )
}
